import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { DatePicker } from 'antd';
import UIValue from './uiValue';
import UIValidation from './uiValidation';
function UIDateComponent(props) {
    const [selectedDate, setSelectedDate] = useState(props.selectedDate || '');
    const handleOnchange = (dateString) => {
        setSelectedDate(dateString);
        props.onChange(dateString);
    };
    return (_jsxs("div", { style: { display: 'flex', marginBottom: '16px' }, children: [_jsx("label", { style: { marginRight: '16px', fontWeight: 'bold', whiteSpace: 'nowrap', width: '140px', textAlign: 'left' }, children: props.title }), _jsx(DatePicker, { style: { flex: 1 }, disabledDate: props.disabledDate, onChange: handleOnchange, value: selectedDate })] }));
}
export default class UIDate extends UIValue {
    title;
    disabledDateRange;
    onChange;
    constructor(s) {
        super(s);
        this.title = this.getProperty('title');
        this.value = '';
    }
    handleDateChange = (dateString) => {
        this.value = dateString;
        this.onChange?.(dateString);
    };
    getComponent() {
        const props = {
            title: this.title,
            disabledDate: this.disabledDateRange,
            selectedDate: this.value,
            onChange: this.handleDateChange,
        };
        return (_jsx(UIValidation, { error: this.error, children: _jsx(UIDateComponent, { ...props }) }));
    }
}
//# sourceMappingURL=uiDate.js.map